export default __webpack_public_path__ + "static/media/element-selector-bg.64732b76.jpg";